import { CheckOutlined, CloseOutlined, CopyOutlined } from '@ant-design/icons'
import type { TablePaginationConfig, TableProps } from 'antd'
import { Button, Card, message, Table, Tooltip } from 'antd'
import copy from 'copy-to-clipboard'
import { useCallback, useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import Breadcrumb from 'component/breadcrumb/breadcrumb'
import ExportCSV from 'component/dropdown/export-csv'
import { BREADCRUMBS } from 'constants/breadcrumb'

import './style.scss'

interface EmailData {
  allocation: number
  email: string
  hashEmail: string
  isSign: number
  isVerify: number
  walletAddress: string
  updatedAt: string
  _id: string
}

const ListEmail = () => {
  const additionalItems = [BREADCRUMBS.EMAIL]
  const [data, setData] = useState<EmailData[]>([])
  const [totalCount, setTotalCount]: any = useState(0)
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [email, setEmail] = useState<string | undefined>(undefined)
  const [walletAddress, setWalletAddress] = useState<string | undefined>(undefined)
  const [hashEmail, setHashEmail] = useState<string | undefined>(undefined)

  const getListEmail = useCallback(
    async (pageIndex = 1, pageSize = 10) => {
      try {
        setLoading(true)
        const listEmailFromApi = await AppAdmin.getListEmail(
          pageSize,
          pageIndex,
          walletAddress,
          email,
          hashEmail
        )
        const dataEmail = listEmailFromApi.data.data.map((item: any, index: number) => ({
          index: index + 1,
          allocation: item?.allocation,
          allocationHMC: item?.allocationHMC,
          allocationVentures: item?.allocationVentures,
          email: item?.email,
          hashEmail: item?.hashEmail,
          isSign: item?.isSign,
          isVerify: item?.isVerify,
          walletAddress: item?.walletAddress,
          updatedAt: item?.updatedAt,
          _id: item._id,
        }))
        setData(dataEmail)
        setTotalCount(listEmailFromApi?.data?.totalCount || 0)
        setLoading(false)
      } catch {
        setLoading(false)
        setData([])
        setTotalCount(0)
      } finally {
        setLoading(false)
      }
    },
    [email, hashEmail, walletAddress]
  )

  useEffect(() => {
    getListEmail(current, pageSize)
  }, [current, getListEmail, pageSize])

  // useEffect(() => {
  //     setCurrent(1);
  //     setPageSize(10);
  // }, [walletAddress, email, hashEmail]);

  const columns: TableProps<EmailData>['columns'] = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      render: (text) => <div>{text}</div>,
    },
    {
      title: 'User Email',
      dataIndex: 'hashEmail',
      key: 'hashEmail',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div>{text}</div>
          <Tooltip title="Copy">
            <Button
              type="link"
              icon={<CopyOutlined />}
              onClick={() => {
                copy(text)
                message.success('Copied Success!')
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: 'User Address',
      dataIndex: 'walletAddress',
      key: 'walletAddress',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <a target="_blank" rel="noreferrer" href={`https://basescan.org/address/${text}`}>
            {text?.slice(0, 6)}... {text?.slice(-6)}
          </a>
          <Tooltip title="Copy">
            <Button
              type="link"
              icon={<CopyOutlined />}
              onClick={() => {
                copy(text)
                message.success('Copied Success!')
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: 'Allocation',
      dataIndex: 'allocation',
      key: 'allocation',
      render: (text) => <div>{text}</div>,
    },
    {
      title: 'Allocation HMC',
      dataIndex: 'allocationHMC',
      key: 'allocationHMC',
      render: (text) => <div>{text}</div>,
    },
    {
      title: 'Allocation Venture',
      dataIndex: 'allocationVentures',
      key: 'allocationVentures',
      render: (text) => <div>{text}</div>,
    },
    {
      title: 'Verify Status',
      dataIndex: 'isVerify',
      key: 'isVerify',
      render: (text) => (
        <>
          {text === 0 ? (
            <div className="check">
              <CloseOutlined />
            </div>
          ) : (
            <div className="checked">
              <CheckOutlined />
            </div>
          )}
        </>
      ),
    },
    {
      title: 'Confirm Wallet Status',
      dataIndex: 'isSign',
      key: 'isSign',
      render: (text) => (
        <>
          {text === 0 ? (
            <div className="check">
              <CloseOutlined />
            </div>
          ) : (
            <div className="checked">
              <CheckOutlined />
            </div>
          )}
        </>
      ),
    },
    {
      title: 'Update At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text) => <>{text}</>,
    },
  ]

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current: newPage, pageSize: newPageSize } = pagination
    setCurrent(newPage || 1)
    setPageSize(newPageSize || 10)
  }

  return (
    <>
      <div className="main-section user">
        <Breadcrumb additionalItems={additionalItems} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <div style={{ marginBottom: 0 }} className="user-search">
            <input
              type="text"
              placeholder="Wallet Address"
              value={walletAddress}
              onChange={(e) => setWalletAddress(e.target.value)}
            />
            <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              placeholder="Hash Email"
              value={hashEmail}
              onChange={(e) => setHashEmail(e.target.value)}
            />
            <Button
              type="primary"
              // onClick={() => getData(current, pageSize)}
              onClick={() => {
                setCurrent(1)
                setPageSize(10)
                getListEmail(1, 10)
              }}
            >
              Search
            </Button>
          </div>
          <ExportCSV />
        </div>
        <Card style={{ margin: '0 auto' }}>
          <Table<EmailData>
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={totalCount < 11 ? false : { total: totalCount, current, pageSize }}
            onChange={handleTableChange}
            scroll={{ x: 1000 }}
            bordered
          />
        </Card>
      </div>
    </>
  )
}

export default ListEmail
